
export class Direction {

  constructor(
    public id: number,
    public title: string,
    public small_title: string
  ) {}
}
